<template>
	<div v-if="projects.length > 0" class="m-b-5">
		<div class="featured-project-banner">
			<a :href="project.url">
				<div class="wa-responsive-image--h450"
					 :style="'background-image: url(' + 'https://www.world-architects.com' + project.featured_photo.image_versions.w1200 + ')' ">
				</div>
			</a>
			<div class="super-module">
				<h5 class="no-margin no-border font-sans bold">
					{{ project.company.company }}
				</h5>
				<h2 class="no-margin no-border m-b-1">
					{{ project.name }}
				</h2>
				<p class="no-margin super-module-image-copyright" v-if="project.featured_photo.copyright_holder">
					&copy; {{ project.featured_photo.copyright_holder }}
				</p>
			</div>
		</div>
	</div>
</template>

<script>
import ProjectsApi from 'WaApi/Projects';

export default {
	name: 'featured-project-banner',
	mounted() {
		ProjectsApi.getFeatured().then((result) => {
			this.projects = result.data.projects;
			let lenght = this.projects.length;

			if (lenght === 1) {
				this.project = this.projects[0];
			}
			if (lenght > 1) {
				let number = Math.floor(Math.random() * lenght);
				this.project = this.projects[number];
			}
		});
	},
	data: function () {
		return {
			projects: [],
			project: {}
		}
	}
}
</script>

<style>
.featured-project-banner {
	position: relative;
}

.super-module {
	right: 0px;
	max-width: 70%;
}
</style>
